const CURRENCY = /\d{1,3}(?:[,]\d{3})*(?:[.]\d{2})/;
const FULL_YEAR = /(?:19|20)\d{2}/; // PT1: accept either 19 or 20 -- PT2: any 2 digits 👉 accepts any year from 1900 - 2099

export default { CURRENCY, FULL_YEAR };
